/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Cognos Analytics Home (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'ca-content/home/caHome',
	'react',
	'react-dom'
], function(caHome, React, ReactDOM) {

	class NavigatorView {
		constructor(options) {
			this.glassContext = options.glassContext;
			this.containerNode = options.containerNode;
			this.itemSpec = options.itemSpec;
			if (options.additionalParams && options.additionalParams.uploadHelper) {
				this.uploadHelper = options.additionalParams.uploadHelper;
			}
		}

		render() {
			let options = {
				glassContext: this.glassContext,
				item: this.itemSpec,
				navigatorId: 'com.ibm.bi.caHome.navigator'
			};
			if (this.uploadHelper) {
				options.uploadHelper = this.uploadHelper;
			}
			ReactDOM.render(React.createElement(caHome.Navigator, options), this.containerNode);
		}

	}
	return NavigatorView;
});